// extracted by mini-css-extract-plugin
export var chevron = "_kc-3";
export var chevronRotated = "_kc-4";
export var image = "_kc-1";
export var imageContainer = "_kc-0";
export var shippingAddress = "_kc-2";